
import { defineComponent } from 'vue'
import Card from '../ss-card'

export default defineComponent({
    name: "bc-scrolltab",
    props: {
        title: { type: String, default: '' }
    },
    components: { Card },
    data() {
        return {
            // 生成一个随机数作为id
            tabId: Math.random().toString(36).substr(2),
            titleList: [] as {
                id: string,
                text: string,
                icon?: string,
                select?: boolean
            }[]
        }
    },
    methods: {
        bodyScroll() {
            const body = document.getElementById('bc-scrolltab-' + this.tabId)
            const titles = body?.getElementsByTagName('h2')
            if(titles) {
                for(let i = 0; i < titles.length; i++) {
                    // 排除父级不是 body 的 h2 标签
                    if(titles[i].parentElement?.id != 'bc-scrolltab-' + this.tabId) continue
                    const title = titles[i]
                    const bodyTop = body?.getBoundingClientRect().top || 0
                    const titleTop = title.getBoundingClientRect().top
                    if(titleTop - bodyTop >= 0 && this.titleList[i]) {
                        this.titleList.forEach(item => {
                            item.select = false
                        })
                        this.titleList[i].select = true
                        break
                    }
                }
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            // 根据正文内的 h2 标签生成导航列表
            const body = document.getElementById('bc-scrolltab-' + this.tabId)
            const titles = body?.getElementsByTagName('h2')
            if(titles) {
                let number = 0
                for(let i = 0; i < titles.length; i++) {
                    // 排除父级不是 body 的 h2 标签
                    if(titles[i].parentElement?.id != 'bc-scrolltab-' + this.tabId) continue
                    const title = titles[i]
                    title.id = 'bc-scrolltab-title-' + this.tabId + '-' + number
                    this.titleList.push({
                        id: title.id,
                        text: title.innerText,
                        icon: title.getAttribute('icon') || undefined,
                        select: i == 0 ? true : undefined
                    })
                    number ++
                }
            }
        });
    }
})
